import React, {useEffect, useState} from "react";
import ProjectService from "../ProjectService";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {calculateDate, getTimeZoneName} from "../../../config/helpingFunctions";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "../point.extensions";
import moment from "moment-timezone";

const SlowTraceReport = ()=>{
    const { t } = useTranslation();

    const search = useLocation().search;

    const did = new URLSearchParams(search).get("did") as string;
    const strtDate = new URLSearchParams(search).get("str_time") as any;
    const edDate = new URLSearchParams(search).get("end_time") as string;
    const projectId = new URLSearchParams(search).get("projectId") as string;
    const [stationName, setStationName] = useState<string>("");

    const [gpsPos, setGpsPos] = useState<string>("");
    const [strtTime, setStrtTime] = useState<any>("");
    const [edTime, setEndTime] = useState<any>("");
    const [headerData, setHeaderData] = useState<any>({});
    const [maxX, setMaxX] = useState<any>();
    const [maxXTime, setMaxXTime] = useState<any>();
    const [maxY, setMaxY] = useState<any>();
    const [maxYTime, setMaxYTime] = useState<any>();
    const [maxZ, setMaxZ] = useState<any>();
    const [maxZTime, setMaxZTime] = useState<any>();
    const [slowTraceXData, setSlowTraceXData] = useState<any>([]);
    const [slowTraceYData, setSlowTraceYData] = useState<any>([]);
    const [slowTraceZData, setSlowTraceZData] = useState<any>([]);
    const projectService = new ProjectService();
    const slowTraceX = {
        chart: {
            type: "column",
            zoomType: "x",
            height: 250,
        },
        title:{
          text: ""
        },
        credits: {
            enabled: false,
        },
        boost: {
            useGPUTranslations: true,
            usePreAllocated: true,
        },
        plotOptions: {
            series: {
                boostThreshold: 2000, // Set the threshold for boosting
            },
        },
        xAxis: {
            crosshair: true,
            type: "datetime",
            label: {
                format: "%H:%M:%S.%L",
            },

        },
        yAxis: {
            title: {
                text: "X-Axis",
            },
        },
        subtitle: {
            text: "",
        },
        series: [
            {
                turboThreshold: slowTraceXData.length,
                data: slowTraceXData,
                showInLegend: false,
                name: "X-Axis",
            },
        ],
    };

    const slowTraceY = {
        chart: {
            type: "column",
            zoomType: "x",
            height: 250
        },
        credits: {
            enabled: false,
        },
        boost: {
            useGPUTranslations: true,
            usePreAllocated: true,
        },
        plotOptions: {
            series: {
                boostThreshold: 2000, // Set the threshold for boosting
            },
        },
        xAxis: {
            crosshair: true,
            type: "datetime",
            label: {
                format: "%H:%M:%S.%L",
            },
        },
        yAxis: {
            title: {
                text: "Y-Axis",
            },
        },
        title: {
            text: "",
        },
        subtitle: {
            text: "",
        },
        series: [
            {
                turboThreshold: slowTraceYData.length,
                data: slowTraceYData,
                showInLegend: false,
                name: "Y-Axis",
            },
        ],
    };

    const slowTraceZ = {
        chart: {
            type: "column",
            zoomType: "x",
            height: 250
        },
        credits: {
            enabled: false,
        },
        boost: {
            useGPUTranslations: true,
            usePreAllocated: true,
        },
        plotOptions: {
            series: {
                boostThreshold: 2000, // Set the threshold for boosting
            },
        },
        xAxis: {
            crosshair: true,
            title: {
                text: `${t('date')}`,
            },
            type: "datetime",
            label: {
                format: "%H:%M:%S.%L",
            },
        },
        yAxis: {
            title: {
                text: "Z-Axis",
            },
        },
        title: {
            text: "",
        },
        subtitle: {
            text: "",
        },
        series: [
            {
                turboThreshold: slowTraceZData.length,
                data: slowTraceZData,
                showInLegend: false,
                name: "Z-Axis",
            },
        ],
    };
    useEffect(()=>{
        setStrtTime(calculateDate( new Date(Number(strtDate)).getTime()));
        setEndTime(calculateDate( new Date(Number(edDate)).getTime()));
        const timezone: any = localStorage.getItem('timezone');

        projectService.getSlowTraceReport(did, strtDate, edDate, projectId).then(response =>{
            const max_X: any = localStorage.getItem('lang') === 'en' ? Number(response['max_X']['max_X']).toFixed(3) : Number(response['max_X']['max_X']).toFixed(3).toString().replace(/\./g, ',')
            setMaxX(max_X);
            const xTime = calculateDate(new Date(Number(response['max_X']['start_time'])).getTime());
            setMaxXTime(xTime);
            const max_Y: any = localStorage.getItem('lang') === 'en' ? Number(response['max_Y']['max_Y']).toFixed(3) : Number(response['max_Y']['max_Y']).toFixed(3).toString().replace(/\./g, ',')
            setMaxY(max_Y);
            const yTime = calculateDate(new Date(Number(response['max_Y']['start_time'])).getTime());
            setMaxYTime(yTime);
            const max_Z: any = localStorage.getItem('lang') === 'en' ? Number(response['max_Z']['max_Z']).toFixed(3) : Number(response['max_Z']['max_Z']).toFixed(3).toString().replace(/\./g, ',')
            setMaxZ(max_Z);
            const zTime = calculateDate(new Date(Number(response['max_Z']['start_time'])).getTime());
            setMaxZTime(zTime);
            setStationName(response['channelX'][0]['station_name'])
            setSlowTraceXData(
                response.channelX.map((point: any) => [
                    moment.tz(point.start_time * 1000, timezone).valueOf(),
                    point.max_X
                ])
            );
            setSlowTraceYData(
                response.channelY.map((point: any) => [
                    moment.tz(point.start_time * 1000, timezone).valueOf(),
                    point.max_Y
                ])
            );
            setSlowTraceZData(
                response.channelZ.map((point: any) => [
                    moment.tz(point.start_time * 1000, timezone).valueOf(),
                    point.max_Z
                ])
            );
            setTimeout(window.print, 7000);
            window.addEventListener("afterprint", (event) => {
                window.close();
            });
        })
    },[])
    return(
        <>
            <div>
                <img
                    alt="DMT-Logo"
                    src="./images/logo.png"
                    className="mr-2"
                    style={{
                        float: "right",
                        paddingRight: "40px",
                        height: "32px"
                    }}
                />
            </div>
            <h2 style={{ textAlign: "center", paddingTop: "10px" }}>
                {t("slow_trace_report")}
            </h2>

            <div className="flex justify-content-between">
                <div className="flex">
                    <p className="my-1 text-bold">{t("start_time")}: </p>
                    <p className="my-1 ml-2"> {strtTime} [{getTimeZoneName()}]</p>
                </div>
                <div className="flex">
                    <p className="my-1 text-bold">{t("end_time")}: </p>
                    <p className="my-1 ml-2"> {edTime} [{getTimeZoneName()}]</p>
                </div>
            </div>
            <div className="flex justify-content-between messinfo">
                <div>
                    <h4>{t("measurement_information")}</h4>
                    <div className="flex">
                        <div className="flex">
                            <p className="my-1 field">{t("station_name")}:</p>
                            <p className="ml-4 my-1"> {stationName}</p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="flex">
                            <p className="my-1 field">{t("company")}:</p>
                            <p className="ml-4 my-1">{headerData["client"]}</p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="flex">
                            <p className="my-1 field">{t("client")}:</p>
                            <p className="ml-4 my-1">{headerData["company"]}</p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="flex">
                            <p className="my-1 field"> {t("gps_position")}:</p>
                            <p className="ml-4 my-1">{gpsPos}</p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="flex">
                            <p className="my-1 field"> {t("comment")}:</p>
                            <p className="ml-4 my-1">{headerData["comment"]}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <h4>
                        {t("devices")} {t("information")}:
                    </h4>
                    <div className="flex">
                        <div className="flex">
                            <p className="my-1 field">Station:</p>
                            <p className="ml-4 my-1">Vipa 130</p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="flex">
                            <p className="my-1 field">Auftraggeber:</p>
                            <p className="ml-4 my-1">Vipa 130</p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="flex">
                            <p className="my-1 field">Firma:</p>
                            <p className="ml-4 my-1">Vipa 130</p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="flex">
                            <p className="my-1 field">Station:</p>
                            <p className="ml-4 my-1">Vipa 130</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid mt-4 justify-content-center">
                <div className="col-md-2 ml-8">
                    <h4>{t("channel_name")}</h4>
                </div>
                <div className="col-md-2 ml-4">
                    <h4>|{t("maxima")}|</h4>
                </div>
                <div className="col-md-2 ml-4">
                    <h4>{t("time_maxima")}</h4>
                </div>

            </div>

            <div className="grid justify-content-center">
                <p className="">K1(X)</p>
                <div className="col-md-2 ml-4">
                    <p className="ml-6">: X</p>
                </div>
                <div className="col-md-2 ml-4">
                    <p className="ml-7">
                        {maxX} mm/s
                    </p>
                </div>
                <div className="col-md-2 ml-4">
                    <p className="ml-5">{maxXTime}</p>
                </div>

            </div>

            <div className="grid justify-content-center">
                <p className="">K1(Y)</p>
                <div className="col-md-2 ml-4">
                    <p className="ml-6">: Y</p>
                </div>
                <div className="col-md-2 ml-4">
                    <p className="ml-7">
                        {maxY} mm/s
                    </p>
                </div>
                <div className="col-md-2 ml-4">
                    <p className="ml-5">{maxYTime}</p>
                </div>
            </div>

            <div className="grid justify-content-center">
                <p className="">K1(Z)</p>
                <div className="col-md-2 ml-4">
                    <p className="ml-6">: Z</p>
                </div>
                <div className="col-md-2 ml-4">
                    <p className="ml-7">
                        {maxZ} mm/s
                    </p>
                </div>
                <div className="col-md-2 ml-4">
                    <p className="ml-5">{maxZTime}</p>
                </div>
            </div>
            <div className='mt-4'>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={slowTraceX}
                />
                <HighchartsReact
                    highcharts={Highcharts}
                    options={slowTraceY}
                />
                <HighchartsReact
                    highcharts={Highcharts}
                    options={slowTraceZ}
                />
            </div>

        </>

    )
}

export default SlowTraceReport;